import { zfUtils } from "./zf_utils";
import { Swiper, Navigation, Pagination, A11y } from "./swiper-config";
export class zfcc {
    static initSlick(main) {
        try {
            var useSwiper = main.find(".swiper").length > 0;
            var maxLength = 0;
            var slider = useSwiper
                ? main.find(".zfcc-content-container")
                : main.find(".zfcc-content-row");
            var isVideoTeaser = main
                .parent()
                .hasClass("zfcfsv-teasers-contact-container");
            var isMobileContactTeaser = main.hasClass("zfcc-teaser");
            if (main.hasClass("zfcc-teaser")) {
                isVideoTeaser ? (maxLength = 4) : (maxLength = 3);
            }
            else if (main.hasClass("zfcc-badge") ||
                main.hasClass("zfcc-contact-person")) {
                if (main.hasClass("zfcc-block-2")) {
                    maxLength = 2;
                }
                else if (main.hasClass("zfcc-block-0")) {
                    maxLength = 3;
                }
                else {
                    maxLength = 4;
                }
            }
            else {
                maxLength = 4;
            }
            if (useSwiper) {
                var contactItemCount = slider.find(".zfcc-contact-item").length;
                var slidesVisibleDesktop = 0;
                if (main.parent().hasClass("zfcc-product-downloads")) {
                    slidesVisibleDesktop = 3;
                }
                else {
                    slidesVisibleDesktop =
                        slider.find(".zfcc-contact-item").length < maxLength
                            ? slider.find(".zfcc-contact-item").length
                            : maxLength;
                }
                var enableNavDots = true;
                var scale = 0;
                if (main.hasClass("zfcc-block-2")) {
                    scale = 2;
                }
                else if (main.hasClass("zfcc-block-3") ||
                    main.hasClass("zfcc-block-0")) {
                    scale = 3;
                }
                else if (main.hasClass("zfcc-block-4")) {
                    scale = 4;
                }
                if (slider.find(".zfcc-contact-item").length <= scale &&
                    scale <= slidesVisibleDesktop) {
                    enableNavDots = false;
                }
                enableNavDots = enableNavDots && contactItemCount > 1;
                if (slider.find(".zfcc-content-row").children(":not(.swiper-slide)")
                    .length > 0) {
                    slider
                        .find(".zfcc-content-row")
                        .children(":not(.swiper-slide)")
                        .addClass("swiper-slide");
                }
                if (!slider.hasClass("swiper-initialized")) {
                    const swiper = new Swiper("#" + slider.attr("id"), {
                        modules: [Navigation, Pagination, A11y],
                        centeredSlides: false,
                        normalizeSlideIndex: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        keyboard: {
                            enabled: true
                        },
                        breakpoints: {
                            1000: {
                                allowTouchMove: false,
                                slidesPerView: slidesVisibleDesktop,
                                navigation: {
                                    enabled: enableNavDots,
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                                pagination: {
                                    enabled: enableNavDots,
                                    el: ".swiper-pagination",
                                    type: "custom",
                                    clickable: true,
                                    renderCustom: function (swiper, current, total) {
                                        var out = "";
                                        for (var i = 1; i < total + 1; i++) {
                                            if (i == current) {
                                                out =
                                                    out +
                                                        '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></button>';
                                            }
                                            else {
                                                out =
                                                    out +
                                                        '<button class="swiper-pagination-bullet" role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></button>';
                                            }
                                        }
                                        return out;
                                    },
                                },
                            },
                            720: {
                                allowTouchMove: true,
                                slidesPerView: 1,
                                navigation: {
                                    enabled: false,
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                                pagination: {
                                    enabled: contactItemCount > 1,
                                    el: ".swiper-pagination",
                                    type: "custom",
                                    clickable: true,
                                    renderCustom: function (swiper, current, total) {
                                        var out = "";
                                        for (var i = 1; i < total + 1; i++) {
                                            if (i == current) {
                                                out =
                                                    out +
                                                        '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></button>';
                                            }
                                            else {
                                                out =
                                                    out +
                                                        '<button class="swiper-pagination-bullet" role="button" aria-label="Go to slide ' +
                                                        i +
                                                        1 +
                                                        '"></button>';
                                            }
                                        }
                                        return out;
                                    },
                                },
                            },
                            0: {
                                allowTouchMove: true,
                                slidesPerView: 1,
                                spaceBetween: isMobileContactTeaser ? 20 : 0,
                                navigation: {
                                    enabled: false,
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                                pagination: {
                                    enabled: true,
                                    el: '.swiper-pagination',
                                    clickable: false,
                                    dynamicBullets: true,
                                    dynamicMainBullets: 1
                                },
                            },
                        },
                        a11y: {
                            enabled: true,
                            nextSlideMessage: "Next slide",
                            prevSlideMessage: "Previous slide",
                            paginationBulletMessage: "Jump to slide {{index}}",
                            slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                            slideRole: "group",
                            itemRoleDescriptionMessage: "slide",
                        },
                    });
                }
            }
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfcc.initSlick() " + err.message);
        }
    }
    static init() {
        $(".zfcc-contact.zfcc-slider").each(function () {
            if ($(this).closest(".zfcacc-accordion-section-content").length == 0 ||
                $(this).closest(".zfcacc-accordion-section-content").is(":visible"))
                zfUtils.loadOnScroll($(this), "delayZFCCLoad", zfcc.initSlick, 1);
        });
        $(".zfcc-contact:not(.zfcc-slider)")
            .parent()
            .parent()
            .each(function () {
            if ($(this).hasClass("zfcfsv-teasers-wrapper")) {
                zfUtils.loadOnScroll($(this).find(".zfcc-contact"), "delayZFCCLoad", zfcc.initSlick, 1);
            }
        });
    }
}
try {
    zfUtils.onReady(zfcc.init);
}
catch (err) {
    console.log("Initalization failed: zfcc.init() " + err.message);
}
